import styled from 'styled-components'

import { Text } from '../text'

import { Color } from '../../theme/color'

export function TitleContainer({ title, desc, children }: { title: string; desc?: string; children?: any }) {
  return (
    <Container>
      <Text size={24} weight={600} lineHeight={34} block={true}>
        {title}
      </Text>
      {desc && (
        <Text size={14} lineHeight={22} color="text_secondary" style={{ marginTop: '8px' }} block={true}>
          {desc}
        </Text>
      )}
      <Content>{children}</Content>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 56px 24px 40px;
  background-color: ${Color.white};
`

const Content = styled.div`
  margin-top: 32px;
`
